const main = $('html, body')

function scrollTo(top, delay = 350) {
  main.animate({ scrollTop: top }, delay)
}

export default scrollTo
